import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { backgroundPalettes, type ScanToPayPalette } from '../../utils';

export const ScanToPayTabsContainer = (props: ScanToPayTabsContainerProps) => {
  const { children, palette } = props;

  return (
    <View style={[styles.container, backgroundPalettes[palette]]}>
      {children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayTabsContainerProps = {
  children: PropsWithChildren['children'];
  palette: ScanToPayPalette;
};
